// active-tab.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ActiveTabService {
  private activeTabSource = new BehaviorSubject<string>('dashboard');
  
  // Use getter instead of property
  get activeTab$(): Observable<string> {
    return this.activeTabSource.asObservable();
  }

  setActiveTab(tab: string) {
    this.activeTabSource.next(tab);
  }
}